module.exports = __webpack_public_path__ + "img/1.fc9301a2.png";